module.exports = new __parcel__URL__("machines_christmas_tree_2023.0d18036b.png").toString();